import React from 'react'; // eslint-disable-line
import { createRoot, } from 'react-dom/client';
import './css/reset-min.css';
import './css/typography.css';
import './css/layout.css';
import './css/ReturnsApp.css';
import './css/tooltip-custom.css';
import './css/print.css';
import ReturnsApp from './components/ReturnsApp';


const container = document.getElementById('root');
const root = createRoot(container);

root.render(<ReturnsApp />);
